import dateFormat from 'dateformat'

export default function formatDateShort(utcDate: any) {
  const date = new Date(utcDate)
  return `${dateFormat(date, 'paddedShortDate')}, ${dateFormat(
    date,
    'h:MM TT'
  )}`
}
